import { FetchUtil } from "../util/FetchUtil";
import { HealioErrorModal } from "../components/healioGlobal/HealioErrorModal"
import { IEmailSignUpRequest } from "../models/EmailSignUp/IEmailSignUpRequest";
import { IEndpoint } from "../models/IEndpoint";

export interface IEmailSignUpResponse {
  MarketingListRegWithEmailSpecialtyEncResult: {
    AccountCreated: boolean;
    AccountGuid: string;
    AccountPreviouslyExist: boolean;
    EmailSent: boolean;
    Message: string;
    PasswordReset: boolean;
    remoteid: string | null;
    UserId: string;
  };
}

export class EmailSignUpService {
  constructor(private readonly _endpoint: IEndpoint) {
  }

  public async subscribe(savedPage: IEmailSignUpRequest): Promise<string|null> {
    if (!this._endpoint) {
      throw new Error("No endpoint available.");
    }

    const response = await FetchUtil
      .sendMessage(this._endpoint, savedPage) as IEmailSignUpResponse;

    const result = response.MarketingListRegWithEmailSpecialtyEncResult;

    if (result.Message.indexOf("error") > 0) {
      HealioErrorModal.triggerHealioErrorModalEvent();
      return null;
    }

    return result.Message;
  }
}
